<template>
  <div class="container">
    <jade-spinner
      size="small"
      color="brand"
    />
    <jade-text
      color="brand"
      weight="semibold"
    >
      {{ $t('time-text', { formattedTime }) }}
    </jade-text>
  </div>
</template>
<script>
import JadeText from '@jade/JadeText/index.vue'
import JadeSpinner from '@jade/JadeSpinner/index.vue'

export default {
  name: 'Spinner',
  components: {
    JadeSpinner,
    JadeText
  },
  data () {
    return {
      time: 0,
      ONE_SECOND_IN_MS: 1000,
      intervalId: null
    }
  },
  props: {
    timeoutInMs: Number
  },
  computed: {
    formattedTime () {
      return new Date(this.time).toISOString().slice(14, 19)
    }
  },
  methods: {
    startInterval () {
      this.intervalId = setInterval(() => {
        this.time -= this.ONE_SECOND_IN_MS
      }, this.ONE_SECOND_IN_MS)
    }
  },
  mounted () {
    this.time = this.timeoutInMs
    this.startInterval()
  },
  watch: {
    time (value) {
      if (value <= 0) {
        clearInterval(this.intervalId)
        this.$emit('expired')
      }
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.container {
  text-wrap: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--global-space-25);
}
</style>
<i18n>
{
  "pt-BR": {
    "time-text": "Expira em: {formattedTime}"
  },
  "en-US": {
    "time-text": "Expires in: {formattedTime}"
  }
}
</i18n>
